import { setVonageMetadata } from '@vonage/media-processor';
import { createVonageMediaProcessor } from '@vonage/ml-transformers';
import env from '../../helpers/env';

// This is copy pasta from @vonage/media-processor, basically.  The only
// difference is their's is an async call, whereas this one is synchronous.
// This only checks for support in the main thread.
const isSupported = (mediaType = 'both') => {
  const isWebkit = env.isSafari || env.isIosWebView;
  if ((mediaType === 'audio' || mediaType === 'both') && (isWebkit || env.isFirefox)) return false;
  const isOldSafari = env.isSafari && env.version < 26;
  if (isOldSafari) return false;
  const hasNativeSupport = (typeof MediaStreamTrackProcessor !== 'undefined'
    && typeof MediaStreamTrackGenerator !== 'undefined');
  const canPolyfill = [
    window.ReadableStream, window.WritableStream,
    window.MediaStream, window.OffscreenCanvas, window.VideoFrame,
    window.AudioContext, window.AudioWorkletNode,
  ].every(prop => prop !== undefined);
  return hasNativeSupport || canPolyfill;
};

// Vonage's low-level machine-learning-based media processor libraries
const ML = {
  isSupported,
  setMetadata: setVonageMetadata,
  createProcessor: createVonageMediaProcessor,
};

export default ML;
